export default "__VITE_ASSET__998d9b28__"